export const DefaultLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="Group_11315"
      data-name="Group 11315"
      transform="translate(-24 -4.984)"
    >
      <circle
        id="Ellipse_18"
        data-name="Ellipse 18"
        cx="25"
        cy="25"
        r="25"
        transform="translate(24 4.984)"
        fill="#fff"
      />
      <g
        id="Group_11314"
        data-name="Group 11314"
        transform="translate(35.538 16.523)"
      >
        <path
          id="Path_10081"
          data-name="Path 10081"
          d="M16.782-12.24H-2.049v3.081H5.359L-.411,11.3H3.536L9.3-9.159H17.37Z"
          transform="translate(2.049 12.24)"
          fill="#4c1036"
          stroke="#4c1036"
          stroke-width="1"
        />
        <path
          id="Path_10082"
          data-name="Path 10082"
          d="M.415,22.673A10.134,10.134,0,0,0,3.5,23.937a14.165,14.165,0,0,0,3.669.606,12.189,12.189,0,0,0,4.69-.813,6.513,6.513,0,0,0,2.96-2.267,5.707,5.707,0,0,0,1-3.323,5.412,5.412,0,0,0-.848-3.029,7.965,7.965,0,0,0-2.181-2.215,33.5,33.5,0,0,0-3.548-2.06Q7.131,9.762,6.144,9.19A5.709,5.709,0,0,1,4.552,7.875a2.637,2.637,0,0,1-.606-1.713A2.242,2.242,0,0,1,5.088,4.119a5.61,5.61,0,0,1,2.942-.692,8.643,8.643,0,0,1,2.544.346,18.4,18.4,0,0,1,2.44.969l1.315-3.081A17.448,17.448,0,0,0,11.2.467,12.29,12.29,0,0,0,7.892,0,10.055,10.055,0,0,0,3.687.813,6.431,6.431,0,0,0,.952,3.029,5.508,5.508,0,0,0,0,6.2a5.567,5.567,0,0,0,1.644,4.1,19.563,19.563,0,0,0,4.9,3.306q1.938.969,2.96,1.558a6.633,6.633,0,0,1,1.679,1.333,2.427,2.427,0,0,1,.658,1.644,2.47,2.47,0,0,1-1.212,2.2,6.487,6.487,0,0,1-3.5.779,10.7,10.7,0,0,1-3.046-.485,17.44,17.44,0,0,1-2.8-1.073Z"
          transform="matrix(0.966, 0.259, -0.259, 0.966, 13.128, 1.663)"
          fill="#3e5bfd"
          stroke="#3e5bfd"
          stroke-width="1"
          opacity="0.504"
        />
      </g>
    </g>
  </svg>
);
